/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppTutorialsRouteImport } from './routes/_app/tutorials'
import { Route as CanvasCanvasIdRouteImport } from './routes/canvas/$canvasId'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SettingsAiUsageRouteImport } from './routes/settings/ai-usage'
import { Route as SettingsApiTokensRouteImport } from './routes/settings/api-tokens'
import { Route as SettingsCanvasRouteImport } from './routes/settings/canvas'
import { Route as SettingsExportRouteImport } from './routes/settings/export'
import { Route as SettingsMemoriesRouteImport } from './routes/settings/memories'
import { Route as SettingsSandboxRouteImport } from './routes/settings/sandbox'
import { Route as SettingsSkillsRouteImport } from './routes/settings/skills'
import { Route as SettingsTemplatesRouteImport } from './routes/settings/templates'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppTutorialsRoute = AppTutorialsRouteImport.update({
  id: '/tutorials',
  path: '/tutorials',
  getParentRoute: () => AppRoute,
} as any)
const CanvasCanvasIdRoute = CanvasCanvasIdRouteImport.update({
  id: '/canvas/$canvasId',
  path: '/canvas/$canvasId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAiUsageRoute = SettingsAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsApiTokensRoute = SettingsApiTokensRouteImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsCanvasRoute = SettingsCanvasRouteImport.update({
  id: '/canvas',
  path: '/canvas',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsExportRoute = SettingsExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMemoriesRoute = SettingsMemoriesRouteImport.update({
  id: '/memories',
  path: '/memories',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSandboxRoute = SettingsSandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSkillsRoute = SettingsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsTemplatesRoute = SettingsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => SettingsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/settings': typeof SettingsRouteRouteWithChildren
  '/': typeof AppIndexRoute
  '/signin': typeof SigninRoute
  '/inbox': typeof AppInboxRoute
  '/tutorials': typeof AppTutorialsRoute
  '/canvas/$canvasId': typeof CanvasCanvasIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/ai-usage': typeof SettingsAiUsageRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/canvas': typeof SettingsCanvasRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/memories': typeof SettingsMemoriesRoute
  '/settings/sandbox': typeof SettingsSandboxRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/inbox': typeof AppInboxRoute
  '/tutorials': typeof AppTutorialsRoute
  '/canvas/$canvasId': typeof CanvasCanvasIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/ai-usage': typeof SettingsAiUsageRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/canvas': typeof SettingsCanvasRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/memories': typeof SettingsMemoriesRoute
  '/settings/sandbox': typeof SettingsSandboxRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/': typeof AppIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/settings': typeof SettingsRouteRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/signin': typeof SigninRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/tutorials': typeof AppTutorialsRoute
  '/canvas/$canvasId': typeof CanvasCanvasIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/ai-usage': typeof SettingsAiUsageRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/canvas': typeof SettingsCanvasRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/memories': typeof SettingsMemoriesRoute
  '/settings/sandbox': typeof SettingsSandboxRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/_app/': typeof AppIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/settings'
    | '/'
    | '/signin'
    | '/inbox'
    | '/tutorials'
    | '/canvas/$canvasId'
    | '/settings/account'
    | '/settings/ai-usage'
    | '/settings/api-tokens'
    | '/settings/canvas'
    | '/settings/export'
    | '/settings/memories'
    | '/settings/sandbox'
    | '/settings/skills'
    | '/settings/templates'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/inbox'
    | '/tutorials'
    | '/canvas/$canvasId'
    | '/settings/account'
    | '/settings/ai-usage'
    | '/settings/api-tokens'
    | '/settings/canvas'
    | '/settings/export'
    | '/settings/memories'
    | '/settings/sandbox'
    | '/settings/skills'
    | '/settings/templates'
    | '/'
    | '/settings'
  id:
    | '__root__'
    | '/settings'
    | '/_app'
    | '/signin'
    | '/_app/inbox'
    | '/_app/tutorials'
    | '/canvas/$canvasId'
    | '/settings/account'
    | '/settings/ai-usage'
    | '/settings/api-tokens'
    | '/settings/canvas'
    | '/settings/export'
    | '/settings/memories'
    | '/settings/sandbox'
    | '/settings/skills'
    | '/settings/templates'
    | '/_app/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  SigninRoute: typeof SigninRoute
  CanvasCanvasIdRoute: typeof CanvasCanvasIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tutorials': {
      id: '/_app/tutorials'
      path: '/tutorials'
      fullPath: '/tutorials'
      preLoaderRoute: typeof AppTutorialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/canvas/$canvasId': {
      id: '/canvas/$canvasId'
      path: '/canvas/$canvasId'
      fullPath: '/canvas/$canvasId'
      preLoaderRoute: typeof CanvasCanvasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/ai-usage': {
      id: '/settings/ai-usage'
      path: '/ai-usage'
      fullPath: '/settings/ai-usage'
      preLoaderRoute: typeof SettingsAiUsageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/api-tokens': {
      id: '/settings/api-tokens'
      path: '/api-tokens'
      fullPath: '/settings/api-tokens'
      preLoaderRoute: typeof SettingsApiTokensRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/canvas': {
      id: '/settings/canvas'
      path: '/canvas'
      fullPath: '/settings/canvas'
      preLoaderRoute: typeof SettingsCanvasRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/export': {
      id: '/settings/export'
      path: '/export'
      fullPath: '/settings/export'
      preLoaderRoute: typeof SettingsExportRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/memories': {
      id: '/settings/memories'
      path: '/memories'
      fullPath: '/settings/memories'
      preLoaderRoute: typeof SettingsMemoriesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/sandbox': {
      id: '/settings/sandbox'
      path: '/sandbox'
      fullPath: '/settings/sandbox'
      preLoaderRoute: typeof SettingsSandboxRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/skills': {
      id: '/settings/skills'
      path: '/skills'
      fullPath: '/settings/skills'
      preLoaderRoute: typeof SettingsSkillsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/templates': {
      id: '/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof SettingsTemplatesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAiUsageRoute: typeof SettingsAiUsageRoute
  SettingsApiTokensRoute: typeof SettingsApiTokensRoute
  SettingsCanvasRoute: typeof SettingsCanvasRoute
  SettingsExportRoute: typeof SettingsExportRoute
  SettingsMemoriesRoute: typeof SettingsMemoriesRoute
  SettingsSandboxRoute: typeof SettingsSandboxRoute
  SettingsSkillsRoute: typeof SettingsSkillsRoute
  SettingsTemplatesRoute: typeof SettingsTemplatesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAiUsageRoute: SettingsAiUsageRoute,
  SettingsApiTokensRoute: SettingsApiTokensRoute,
  SettingsCanvasRoute: SettingsCanvasRoute,
  SettingsExportRoute: SettingsExportRoute,
  SettingsMemoriesRoute: SettingsMemoriesRoute,
  SettingsSandboxRoute: SettingsSandboxRoute,
  SettingsSkillsRoute: SettingsSkillsRoute,
  SettingsTemplatesRoute: SettingsTemplatesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface AppRouteChildren {
  AppInboxRoute: typeof AppInboxRoute
  AppTutorialsRoute: typeof AppTutorialsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppInboxRoute: AppInboxRoute,
  AppTutorialsRoute: AppTutorialsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  SigninRoute: SigninRoute,
  CanvasCanvasIdRoute: CanvasCanvasIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
